function hideResults()
{
var mencategorySize = document.querySelector('.js-size-message2 .menCategory1');
var womencategorySize = document.querySelector('.js-size-message2 .womenCategory1');
      if(mencategorySize){
          mencategorySize.innerHTML = ""; 
      }
      if(womencategorySize){
          womencategorySize.innerHTML = ""; 
      }
}


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
  
var changeEvent = new Event('change', { bubbles: true });
var isthisWomen = getUrlParameter('v');

var mencategorySize = document.querySelector('.js-size-message2 .menCategory1');
var womencategorySize = document.querySelector('.js-size-message2 .womenCategory1');
var firstOne = document.querySelector("#ring_slide");

if(isthisWomen=="wom"){
  //women 
   firstOne.setAttribute("min",45);
   firstOne.setAttribute("max",60);

   firstOne.dispatchEvent(changeEvent);

   mencategorySize.classList.remove('showIT1');
   womencategorySize.classList.add('showIT1'); 
}else{
  //men 
   firstOne.setAttribute("min",54);
   firstOne.setAttribute("max",64);

   firstOne.dispatchEvent(changeEvent);

   mencategorySize.classList.add('showIT1');
   womencategorySize.classList.remove('showIT1'); 
} 

//alert(isthisWomen);



// $(document).on("input", "#ring_slide", function() {
$('#ring_slide').on('input', function() { 
 
    showResults11();
    //hideResults();

  
    $('#ring_size').html(this.value); 
  
    var circumference = (this.value);

    //circumference = mmToPxCSS(this.value)
   

    var diameter = (circumference/3.14159) + 15 + 'mm';
  
    $('.ring_img').css({
        'width': diameter,
    });
 
});



  function showResults11(){
   var sizeinmm = 30; 
      sizeinmm = parseInt(document.querySelector('input#ring_slide').value); 
     
      var sizeGuideForWomen = "60",sizeGuideFormen = "60";

 /*
 // MEN S(56),M(60),L(64)
      if(sizeinmm >= 61)
      {
        // 61 and above -> L
        sizeGuideFormen="64";
      }else if(sizeinmm >= 57)
      {
        // 57 and above till 60 -> M
        sizeGuideFormen="60";
      }else{
        // Below 57 -> S
        sizeGuideFormen="56";
      }
*/

//54-64
switch(sizeinmm){case 64:case 63:case 62:case 61:sizeGuideFormen="64";break;case 60:case 59:case 58:case 57:sizeGuideFormen="60";break;default:sizeGuideFormen="56"}

    
 /*
      // WOMEN XXS(48),XS(50),S(52),M(54),L(56),XL(58),XXL(60)
      if(sizeinmm >= 59)
      {
        // 59 and above -> XXL
        sizeGuideForWomen="60";
      }else if(sizeinmm >= 57)
      {
        // 57 and above -> XL
        sizeGuideForWomen="58";
      }else if(sizeinmm >= 55)
      {
        // 55 and above -> L
        sizeGuideForWomen="56";
      }else if(sizeinmm >= 53)
      {
        // 53 and above -> M
        sizeGuideForWomen="54";
      }else if(sizeinmm >= 51)
      {
        // 51 and above -> S
        sizeGuideForWomen="52";
      }else if(sizeinmm >= 49)
      {
        // 49 and above -> XS
        sizeGuideForWomen="50";
      }else
      {
        // Below 49 -> XXS
        sizeGuideForWomen="48";
      }
*/
    
//45-60
switch(sizeinmm){case 60:case 59:sizeGuideForWomen="60";break;case 58:case 57:sizeGuideForWomen="58";break;case 56:case 55:sizeGuideForWomen="56";break;case 54:case 53:sizeGuideForWomen="54";break;case 52:case 51:sizeGuideForWomen="52";break;case 50:case 49:sizeGuideForWomen="50";break;default:sizeGuideForWomen="48"}

    var resultmessage;   
      resultmessage = document.querySelector('p.js-size-message2'); 

     resultmessage.classList.remove('hidden');
    
     resultmessage.querySelector('span.menCategory1').innerHTML = sizeGuideFormen;
     resultmessage.querySelector('span.womenCategory1').innerHTML = sizeGuideForWomen;

}

